import { MEMBER_RELATIONS_NAME } from './constants';

export const getCorrespondentName = (correspondentName: string, localeName: string) =>
  correspondentName === MEMBER_RELATIONS_NAME ? localeName : correspondentName;
